import "regenerator-runtime/runtime";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Auth0Provider } from "@auth0/auth0-react";

import AuthenticatedProvider from "./components/AuthenticatedProvider";
import Routes from "./routes";
import store from "./store";
import { providerProps } from "./utils/auth0";

export default function TTapp() {
  return (
    <Provider store={store}>
      <AuthenticatedProvider>
        <Routes store={store} />
      </AuthenticatedProvider>
    </Provider>
  );
}

const app = document.getElementById("app");

// Render MGTTapp build to the DOM
ReactDOM.render(
  <Auth0Provider {...providerProps}>
    <TTapp />
  </Auth0Provider>,
  app
);



// WEBPACK FOOTER //
// ./app/index.jsx